export default __webpack_public_path__ + "d28ea06d7353008e0e41fd91ad6d72af.png";